export const SAVE_ALL_VEHICLE_MOVEMENT_RECORDS =
  'SAVE_ALL_VEHICLE_MOVEMENT_RECORDS'
export const SAVE_VEHICLE_MOVEMENT_RECORD = 'SAVE_VEHICLE_MOVEMENT_RECORD'
